















































































































































































































































































import { Vue, Component, Watch } from 'vue-property-decorator';
import { TextInput, Uploader } from '@/components';
import { Tab, Tabs, Button } from 'vant';
import { appShare, wxShareInfo, isWeiXin } from '@/common/ts/common';
import { getRules, getBaseinfo } from '@/api/api';
import qs from 'qs';
import {
  recommend,
  ifFunction,
  ifWithdrawal,
  topNews,
  withdrawalSave,
  pictureSave,
  save,
  nowIcon,
  ifGroup,
} from './api';
import { FileType } from '@/common/ts/enum';
import * as config from './config';
import { Toast, Dialog } from 'vant';
import ClipboardJS from 'clipboard';
Vue.use(Tab).use(Tabs).use(Button).use(Dialog);

let timer: any = null;
@Component({
  components: {
    TextInput,
    Uploader,
  },
})
export default class First extends Vue {
  baseInfo = {};
  activeNum = 1;
  SubData: any[] = [];
  getList: any[] = [];
  getListTest = ['1111', '2222', '33333', '4444', '55555', '352'];
  copyList = true;
  Rules = '';
  ifFunctionButton: boolean = false;
  ifWithdrawalButton: boolean = false;
  ifGroupButton: boolean = false;
  ifWithdrawalText = '';
  ifFunctionText = '';
  ifGroupText = '';
  copyWeixin = 'SYXW009';
  copynum = 0;
  showNowIcon: boolean = false;
  numberData = {};
  value = '';
  showPicker: boolean = false;
  noIfFunction: boolean = false;
  pointOut: boolean = false;
  SHOW_1: boolean = false;
  SHOW_2: boolean = false;
  SHOW_3: boolean = false;
  SHOW_4: boolean = false;
  SHOW_5: boolean = false;
  FileType = FileType;
  // 上传截图
  cover = '';
  // 提交申请
  name = '';
  fans = '';
  number = '';
  weixinid = '';
  friend = '';
  COVER = '';
  unionid?: string = '';
  identity?: number; // 身份
  containTopActiveIndex = 0;
  option = config.OPTHINES;
  get areasPickerData() {
    return this.option.areasPickerData;
  }
  get bottom() {
    return this.containTopActiveIndex * 23 + 'px';
  }
  mounted() {
    setInterval(() => {
      if (this.containTopActiveIndex < this.getListTest.length) {
        this.containTopActiveIndex += 1;
      } else {
        this.containTopActiveIndex = 0;
      }
    }, 1000);
    // window.addEventListener('transitionend', this.handTransitionend
  }
  created() {
    // 微信登录
    if (isWeiXin() && !window.localStorage.getItem('unionid')) {
      this.WechatLogin();
    } else if (isWeiXin()) {
      this.unionid = window.localStorage.getItem('unionid') || '';
    } else if (!isWeiXin()) {
      console.log('让非微信环境的unionid为null');
      this.unionid = '';
      window.localStorage.setItem('unionid', '');
    }
    // autoOpenApp();
    window.userInfoChange = () => {
      this.$router.go(0);
    };
    this.init();
    getBaseinfo(this.option.voteName).then((res: any) => {
      this.baseInfo = res.data;
      this.$addPv(res.data.activityId);
    });
    // 推荐社群图标
    recommend().then((res: any) => (this.SubData = res.data.slice(0, 5)));
    // 规则
    getRules(this.option.voteName).then((res: any) => (this.Rules = res.data));
    // 分享
    appShare({
      title: '上游新闻社群伙伴计划',
      url: window.location.href,
      subtitle: '上游新闻社群伙伴计划',
      classId: -1,
      id: -1,
      image: 'https://image2.cqcb.com/1075dd015b5d3b3545e6379f33081b4e.jpeg',
      type: 3,
    });
    wxShareInfo({
      title: '上游新闻社群伙伴计划',
      subtitle: '上游新闻社群伙伴计划',
      image: 'https://image2.cqcb.com/1075dd015b5d3b3545e6379f33081b4e.jpeg',
    });
  }
  async init() {
    // 新闻分享
    const res = await topNews();
    if ((res as any).code === 200 && res.data.length > 0) {
      this.getList = res.data;
      timer = setInterval(() => this.rollStart(), 50);
    }
    // 推荐社群图标
    const nowIconRes = await nowIcon();
    switch ((nowIconRes as any).code) {
      case 200:
        this.showNowIcon = true;
        this.numberData = nowIconRes.data;
    }
    // 是否可点击申请认证群主
    const ifGroupRes = await ifGroup();
    switch ((ifGroupRes as any).code) {
      case 200:
        this.ifGroupButton = true;
        break;
      case 202:
        this.identity = ifGroupRes.data;
      case 203:
        this.ifGroupText = (ifGroupRes as any).msg;
        break;
      case 500:
        this.ifGroupText = (ifGroupRes as any).msg;
        break;
    }
    // 是否可点击去领任务和上传截图
    const ifFunctionRes = await ifFunction();
    switch ((ifFunctionRes as any).code) {
      case 200:
        this.ifFunctionButton = true;
      case 203:
        this.ifFunctionText = (ifFunctionRes as any).msg;
      case 500:
        this.ifFunctionText = (ifFunctionRes as any).msg;
    }
    // 是否可点击申请提现
    const ifWithdrawalRes = await ifWithdrawal();
    switch ((ifWithdrawalRes as any).code) {
      case 200:
        this.ifWithdrawalButton = true;
      case 203:
        this.ifWithdrawalText = (ifWithdrawalRes as any).msg;
      case 500:
        this.ifWithdrawalText = (ifWithdrawalRes as any).msg;
    }
  }
  // 微信登录
  WechatLogin() {
    console.log('开始微信登录');
    const { code, source } = qs.parse(location.search, {
      ignoreQueryPrefix: true,
    });
    if (isWeiXin() && !code) {
      const appId = 'wx1949ed4a473b87ed';
      location.href = `https://activity.cqcb.com/wechat-auth.html?appId=${appId}&backUrl=${encodeURIComponent(
        location.href,
      )}`;
    }
  }
  // 新闻分享滚动效果
  rollStart() {
    // console.log('??????');
    const box = this.$refs.box;
    const list1 = this.$refs.list1;
    const list2 = this.$refs.list2;
    // console.log(
    //   '1',
    //   (box as HTMLElement).scrollTop,
    //   Math.floor((box as HTMLElement).scrollHeight),
    // );
    if ((box as HTMLElement).scrollHeight / 2 < 100) {
      this.copyList = false;
    } else {
      if (
        (box as HTMLElement).scrollTop ===
        Math.floor((box as HTMLElement).scrollHeight / 2)
      ) {
        (box as HTMLElement).scrollTop = 0;
      } else {
        (box as HTMLElement).scrollTop++;
      }
    }
  }
  // 是否可申请认证群主
  Login(e: any) {
    if (window.udid) {
      if (window.gettoken() && window.gettoken() !== 'null') {
        switch (e) {
          case 1:
            this.identity = 1;
            this.ifGroupFuc();
            break;
          case 2:
            this.identity = 2;
            this.ifDarenFuc();
            break;
          default:
            break;
        }
      } else {
        window.handleMessage('{"action":"mUserLogin","data":""}');
      }
    } else if (!isWeiXin() && !window.udid) {
      window.location.href =
        'shangyounews://{"dt":"7","url":"' + location.href + '"}';
    } else if (isWeiXin() && this.unionid) {
      switch (e) {
        case 1:
          this.identity = 1;
          this.ifGroupFuc();
          break;
        case 2:
          this.identity = 2;
          this.ifDarenFuc();
          break;
        default:
          break;
      }
    }
  }
  // 认证群主
  ifGroupFuc() {
    if (this.ifGroupButton) {
      this.SHOW_1 = !this.SHOW_1;
    } else {
      Toast.fail(this.ifGroupText);
    }
  }
  // 认证达人
  ifDarenFuc() {
    if (this.ifGroupButton) {
      this.SHOW_5 = !this.SHOW_5;
    } else {
      Toast.fail(this.ifGroupText);
    }
  }
  // 活动规则
  fetchRules() {
    this.SHOW_2 = !this.SHOW_2;
  }
  // 去领任务
  getTask() {
    if (this.ifFunctionButton) {
      this.SHOW_3 = !this.SHOW_3;
    } else {
      Toast.fail(this.ifFunctionText);
    }
  }
  // 上传截图
  Upload() {
    if (this.ifFunctionButton) {
      this.SHOW_4 = !this.SHOW_4;
    } else {
      Toast.fail(this.ifFunctionText);
    }
  }
  // 申请提现
  Cash() {
    if (this.ifWithdrawalButton && this.ifFunctionButton) {
      Dialog.confirm({
        message: '你确定要申请提现吗？',
      })
        .then(() => {
          this.confirmWithdrawalSave();
        })
        .catch(() => {
          // on cancel
        });
    } else if (!this.ifFunctionButton) {
      Toast.fail(this.ifFunctionText);
    } else if (!this.ifWithdrawalButton) {
      Toast.fail(this.ifWithdrawalText);
    }
  }

  // 确认提现
  async confirmWithdrawalSave() {
    const res = await withdrawalSave();
    switch ((res as any).code) {
      case 200:
        Toast.success((res as any).msg);
      case 203:
        Toast.fail((res as any).msg);
      case 500:
        Toast.fail((res as any).msg);
    }
  }
  onClose(index: any) {
    this.SHOW_1 = false;
    this.SHOW_2 = false;
    this.SHOW_3 = false;
    this.SHOW_4 = false;
    this.SHOW_5 = false;
  }

  // getOssImagesUrls(result: any) {
  //   this.cover = result[0];
  //   console.log('result', result, this.cover);
  // }
  // 复制微信号
  copy() {
    const copy = this.$refs.copy; // 添加
    let clipboard = new ClipboardJS(copy, {
      text: (trigger: any) => {
        return this.copyWeixin;
      },
    });
    clipboard.on('success', () => {
      this.copynum++;
      Toast.success('复制成功');
      if (this.copynum >= 1) {
        clipboard.destroy();
        clipboard = new ClipboardJS(copy);
      }
    });
    clipboard.on('error', () => {
      Toast.fail('复制失败');
    });
  }
  // 粉丝覆盖范围
  startPicker() {
    console.log('object');
    this.showPicker = true;
  }
  onConfirm(e: string, index: number) {
    this.value = e;
    this.COVER = e;
    this.showPicker = false;
  }
  enterOtherPage(item: any) {
    if (item.url && item.url !== '') {
      window.location.href = item.url;
    }
  }
  // 提交申请
  async submit() {
    console.log(
      'this',
      this.name,
      this.number,
      this.fans,
      this.weixinid,
      this.COVER,
      this.identity,
    );
    if (this.name && this.number && this.fans && this.weixinid) {
      const data = {
        name: this.name,
        number: this.number,
        weixin: this.weixinid,
        fans: this.fans,
        main_cover: this.COVER,
        work_type: this.identity,
        unionid: this.unionid,
      };
      const res = await save(this.option.voteName, data);
      if ((res as any).code === 200) {
        Toast.success((res as any).msg);
        this.SHOW_1 = false;
        this.SHOW_5 = false;
        this.init();
      } else {
        Toast((res as any).msg);
      }
    } else {
      Toast.fail('填写完整信息');
    }
  }
  // 确认上传截图
  async submitCover() {
    (this.$refs.uploaderImage as Uploader).uploadToOss().then((res: any) => {
      console.log('res[0]', res.toString().replace(/,/g, '|'));
      const coverData = res.toString().replace(/,/g, '|');
      if (!coverData) {
        Toast.fail('请上传截图');
        return;
      }
      pictureSave({ cover: coverData, unionid: this.unionid }).then(
        (res: any) => {
          if (res.code === 200) {
            Toast.success('提交成功');
            this.SHOW_4 = false;
            this.init();
          }
        },
      );
    });
  }
  destroyed() {
    clearInterval(timer);
  }
}
